export function maskEmail(email = '') {
  return email.replace(/(\w{1})[\w.-]+(\w{1})@([\w.]+)/, (match, first, last, domain) => {
    return first + '********' + last + '@' + domain
  })
}
